import React from "react";
import styles from "./styles/MechatronicsHero.module.css";
import heroBg from "../../../images/ChannelPartner.jpg";

export default function MechatronicsHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Alliance Mechatronics Division</h1>
          <p className={styles.description}>
            smart and cost effective factory automation solutions that are taking businesses to the next level
          </p>
        </div>
      </div>
    </section>
  );
}
